import { type ModalConfigName } from './modalConfigs';
import { Feature, isAvailable, hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';

const hasActiveScripts = (types: string[]) => {
	return (
		isAvailable(Feature.UI_SCRIPTS) &&
		AppService.getScripts().some(script => script.active && types.includes(script.type))
	);
};

const shouldOpenModal = (name: ModalConfigName) => {
	const hasEditClientReact = hasSoftDeployAccess('EDIT_CLIENT_REACT');
	const hasReactEditContactModal = hasSoftDeployAccess('REACT_EDIT_CONTACT_MODAL');
	switch (name) {
		case 'CreateAccount':
			return !hasActiveScripts(['client_edit']);
		case 'EditClient':
			return hasEditClientReact && !hasActiveScripts(['client_edit']);
		case 'EditContact':
			return hasReactEditContactModal && !hasActiveScripts(['contact_edit']);
		default:
			return true;
	}
};

export default shouldOpenModal;
